export default __webpack_public_path__ + "static/media/315.93efe1a6.jpg";